import type { usuarios as pt } from '../pt-BR/usuarios';
import type { Traducao } from '../Traducao';

export const usuarios = {
  titulo: 'Usuarios y perfiles',
  descricao: 'Usuarios que ya han entrado en My Update y sus perfiles.',
  filtros: {
    limpar: 'Limpiar todo',
    rotulo: '{{filtro}}: {{valor}}',
    aplicados: 'Filtros aplicados',
    remover: 'Quitar filtro {{filtro}}',
    botao: 'Filtros',
    fechar: 'Cerrar',
    perfis: { administrador: 'Administrador', profissional: 'Solo profesional' },
    entrou: { rotulo: 'Entró al sistema', sim: 'Sí', nao: 'No' },
  },
  porPagina: 'Elementos por página',
  semResultado: 'Ningún usuario con estos filtros.',
  colunas: {
    nome: 'Nombre',
    email: 'Correo electrónico',
    perfis: 'Perfiles',
    ultimoLogin: 'Último acceso al sistema',
    cadastro: 'Registro en Axiis',
    acoes: 'Acciones',
  },
  nuncaEntrou: 'Nunca entró',
  vinculo: {
    vinculado: 'Vinculado',
    sem_correspondencia: 'Sin coincidencia',
    duplicado: 'Duplicado',
    nao_verificado: 'No verificado',
  },
  acoes: { promover: 'Hacer administrador', rebaixar: 'Quitar administrador' },
  confirmar: {
    promover: '¿Hacer administrador a {{nome}}?',
    rebaixar: '¿Quitar el perfil de administrador a {{nome}}? La persona sigue como profesional.',
  },
  promovido: '{{nome}} ahora es administrador.',
  rebaixado: '{{nome}} ya no es administrador.',
  vazio: 'Ningún usuario encontrado.',
} as const satisfies Traducao<typeof pt>;
